import type { ImpactCenterCurationOverviewResponse } from "@shared/services/impact-center/getImpactCenterCurationOverview.ts";

const TOUR_SERVER_NAME = "demo";

export default async (): Promise<ImpactCenterCurationOverviewResponse> => ({
  results: [
    {
      technicalServerName: TOUR_SERVER_NAME,
      overview: {
        policies: [
          {
            last_at: 0,
            policy_id: 1,
            policy_name: "block-malicious",
            condition_name: "Malicious package",
            condition_category: "security",
            count: 5,
          },
        ],
        packageTypes: [],
        suggestions: {
          status: "ready",
          protection_summary_percentage: {
            protection_level: 59,
            potential_coverage: 67,
            industry_benchmark: 80,
          },
        },
      },
    },
  ],
});
